import React, { useState } from 'react';
import giftPlans from 'Config/GiftPlans.json';
import { GiftCardInfoModal } from './GiftCardInfoModal/index';

import './giftCardInfo.css';

export const GiftCardInfo = ({ giftId }) => {
  const [showModal, toggleModal] = useState(false);
  const onClick = () => toggleModal(true);
  const giftData = giftPlans[giftId];

  if (!giftData) {
    return null;
  }
  return (
    <div className="giftCardInfo">
      <div className="giftCardInfoTitle">Congrats! Your gift includes:</div>
      <div role="button" className="giftCardImgWrapper" onClick={onClick}>
        <span className="giftCardImageButton">Open</span>
        <img className="giftCardImg" src={giftData.imgSrc.default} alt="giftImg" />
      </div>
      <div className="giftCardInfoData">
        <div className="giftCardTitle">{giftData.title}</div>
        <div className="giftCardDescription">{giftData.description}</div>
        <div className="giftCardDescription">{giftData.subDescription}</div>
        <div className="giftCardDescription">{giftData.subDescription2}</div>
      </div>
      <GiftCardInfoModal isOpen={showModal} src={giftData.imgSrc.modal} onClose={() => toggleModal(false)} />
    </div>
  );
};
